import React from 'react';
import PropTypes from 'prop-types';
import useProfileDrawer, { participantUserName } from './useProfileDrawer';

// Renders a messaging participant's display name. When the participant maps to a
// real user, the name becomes a button that opens the shared Succession profile
// drawer (the same surface as /succession/search). Participants with no real user
// (the "Paddy" agent, incomplete profiles) render as plain, non-interactive text.
//
// Privacy/visibility/blocked gating is NOT done here — it is inherited from the
// shared drawer (canViewProfile + getUser). This component only supplies a
// user_name and triggers the open.
const ParticipantName = ({
  participant,
  className = '',
  source = 'messages',
  stopPropagation = false,
  children,
}) => {
  const openDrawer = useProfileDrawer();
  const label = children != null
    ? children
    : (participant?.allowed_name || participant?.name || 'Unknown User');

  if (!participantUserName(participant)) {
    return <span className={className}>{label}</span>;
  }

  return (
    <button
      type="button"
      className={`${className} appearance-none bg-transparent border-0 p-0 m-0 text-left cursor-pointer hover:underline focus:underline focus:outline-none`}
      onClick={(e) => {
        if (stopPropagation) e.stopPropagation();
        openDrawer(participant, { source });
      }}
      title="View profile"
    >
      {label}
    </button>
  );
};

ParticipantName.propTypes = {
  participant: PropTypes.shape({
    user_name: PropTypes.string,
    fb_user_name: PropTypes.string,
    name: PropTypes.string,
    allowed_name: PropTypes.string,
  }),
  className: PropTypes.string,
  source: PropTypes.string,
  stopPropagation: PropTypes.bool,
  children: PropTypes.node,
};

ParticipantName.defaultProps = {
  participant: null,
  className: '',
  source: 'messages',
  stopPropagation: false,
  children: null,
};

export default ParticipantName;
